<template>
	<div class="product">
		<search-product
			v-on:addProduct="addProduct"
			v-on:onSubmit="onSubmit"
			v-on:resetSearch="resetSearch"
			:search="search">
		</search-product>
		<add-product
			:dialogProduct="dialogProduct"
			v-on:cancel="cancel"
			:productTags="productTags"
			:product="product"
			:fromMaterial="'0'">
		</add-product>
		<UploadImgs
			@close="closeUploadImg"
			@refresh="refreshUploadImg"
			:show="showUploadImg"
			:isReUpload="isReUpload"
			:product="productItem"
		/>
		<LookImgs @close="closeLookImg" :show="showLookImg" :product="productItem" />
		<ProductSimilarDialog
			:show="showSimilarDialog"
			:product="similarProduct"
			@close="closeSimilarDialog"
			@refresh="refreshSimilarProduct"
		/>
		<div class="vue-padding">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="productList"
				style="width: 100%"
				max-height="700"
				:border="true"
				@sort-change="sortChange">
				<el-table-column
					prop="typeName"
					:show-overflow-tooltip="true"
					:label="$t('product.productTypeName')"
					width="160"
					:align="'center'"
					sortable="custom"></el-table-column>
				<el-table-column
					prop="name"
					:show-overflow-tooltip="true"
					:label="$t('product.goodsName')"
					width="200"
					:align="'center'"
					sortable="custom"></el-table-column>
				<el-table-column
					:label="$t('product.productTag')"
					width="190"
					:align="'center'"
					prop="goodsTags">
					<template slot-scope="scope">
						<el-tag
							size="mini"
							class="custom-tag"
							v-for="(item, index) in scope.row.goodsTags"
							:key="index"
							>{{ item.name }}</el-tag
						>
					</template>
				</el-table-column>
				<el-table-column
					prop="no"
					:show-overflow-tooltip="true"
					:label="$t('product.code')"
					width="120"
					:align="'center'"></el-table-column>
				<el-table-column
					prop="costPrice"
					:show-overflow-tooltip="true"
					:label="$t('product.price')"
					width="120"
					:align="'center'"
					sortable="custom"></el-table-column>
				<el-table-column
					prop="url"
					:label="$t('product.image')"
					width="130"
					:align="'center'">
					<template slot-scope="scope">
				<el-image
					style="width: 60px; height: 60px"
					:src="scope.row.url"
					fit="contain"></el-image>
					</template>
				</el-table-column>
				<el-table-column
					prop="num"
					:show-overflow-tooltip="true"
					:label="$t('product.saleCount')"
					width="80"
					:align="'center'"
					sortable="custom"></el-table-column>
			<el-table-column
				label="Audit Status"
				width="120"
				:align="'center'">
				<template slot-scope="scope">
					<span>{{ handlerROpenDoorStatus(scope.row) }}</span>
				</template>
			</el-table-column>
				<el-table-column
					prop="openDoorSkuDTO.rejectReasion"
					:label="$t('product.rejectReason')"
					width="220"
					:show-overflow-tooltip="true"
					:align="'center'">
					<template slot-scope="scope">
						<span>{{ handlerRejectReason(scope.row) }}</span>
					</template>
				</el-table-column>
				<!-- 
				<el-table-column
					prop="notes"
					:label="$t('product.notes')"
					:show-overflow-tooltip="true"></el-table-column> -->
				<el-table-column
					prop="createTime"
					:label="$t('product.createTime')"
					:align="'center'"></el-table-column>
				<el-table-column
					fixed="right"
					:label="$t('common.operate')"
					:width="$i18n.locale == 'zh_CN' ? 420 : 460"
					:align="'center'">
					<template slot-scope="scope">
						<el-button
							size="mini"
							v-if="handlerIsStatus(scope.row, null)"
							@click="handlerUploadImg(scope.row)"
							>{{ $t("product.uploadImgs") }}</el-button
						>
						<el-button
							size="mini"
							v-if="handlerIsStatus(scope.row, 3)"
							@click="handlerReUploadImg(scope.row)"
							>{{ $t("product.reUploadImgs") }}</el-button
						>
						<el-button
							size="mini"
							v-if="!handlerIsStatus(scope.row, null)"
							@click="handlerLookImgs(scope.row)"
							>{{ $t("product.lookImgs") }}</el-button
						>
						<el-button
							size="mini"
							v-hasPerm="['product:update']"
							@click="editProductType(scope.row)"
							>{{ $t("common.edit") }}</el-button
						>
						<el-button
							size="mini"
							type="warning"
							v-if="handlerIsStatus(scope.row, 2)"
							@click="openSimilarDialog(scope.row)"
							>{{ $t("productSimilar.markSimilar") }}</el-button
						>
						<el-button
							size="mini"
							v-hasPerm="['product:delete']"
							type="danger"
							@click="delProductType(scope.row)"
							>{{ $t("common.delete") }}</el-button
						>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				v-if="productList.length > 0"
				background
				layout="total,sizes,prev, pager, next,jumper"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				@size-change="sizeChange"
				:page-size="page.pageSize"
				@current-change="currentChange"></el-pagination>
		</div>
	</div>
</template>

<script>
import searchProduct from "_c/product/SearchProduct";
import addProduct from "_c/product/AddProduct";
import UploadImgs from "_c/product/UploadImgs.vue";
import LookImgs from "_c/product/LookImgs.vue";
import ProductSimilarDialog from "_c/product/ProductSimilarDialog.vue";
export default {
	name: "Product",
	components: {
		searchProduct,
		addProduct,
		UploadImgs,
		LookImgs,
		ProductSimilarDialog,
	},
	data() {
		return {
			search: {
				name: "",
				typeName: "",
				no: "",
			},
			loading: false,
			page: {
				pageSize: 10,
				pageIndex: 1,
			},
			productList: [],
			dialogProduct: false,
			product: {
				costPrice: "",
				goodsTags: [],
				name: "",
				typeId: "",
				url: "",
				content: "",
				introduction: "",
				no: "",
				goodsBarcode: "",
				notes: "",
				id: "",
			},
			productTags: [],
			showUploadImg: false,
			productItem: {},
			showLookImg: false,
			openDoorResList: [],
			isReUpload: false,
			showSimilarDialog: false,
			similarProduct: {},
		};
	},
	async mounted() {
		await this.handlerOpenDoorSh();
		this.currentChange();
		this.listProductTag();
	},
	methods: {
		sortChange(column) {
			if (column.order === "ascending") {
				this.search.order = "asc";
				this.search.sort = column.prop;
			} else if (column.order === "descending") {
				this.search.order = "desc";
				this.search.sort = column.prop;
			} else {
				delete this.search.sort;
				delete this.search.order;
			}
			this.page.pageIndex = 1;
			this.currentChange();
		},
		sizeChange(pageSize) {
			this.page.pageSize = pageSize;
			this.currentChange();
		},
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.search, this.page);
			this.$api
				.request(this.$url.Product.page, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.productList = res.data.records;
						this.page.totalSize = parseInt(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		listProductTag() {
			this.$api
				.request(this.$url.ProductTag.list, this.$method.get)
				.then(res => {
					if (res.code === 0) {
						this.productTags = res.data;
					}
				});
		},
		addProduct() {
			this.dialogProduct = true;
		},
		onSubmit(data) {
			this.search = data;
			this.currentChange();
		},
		resetSearch(data) {
			this.search = data;
			this.currentChange();
		},
		cancel(dialog, state) {
			this.dialogProduct = dialog;
			if (state) {
				this.currentChange(this.page.pageIndex);
			}
		},
		editProductType(row) {
			this.dialogProduct = true;
			Object.keys(this.product).forEach(key => {
				this.product[key] = row[key];
			});
		},
		delProductType(row) {
			this.$confirm(this.$t("product.delete"), this.$t("common.warning"), {
				confirmButtonText: this.$t("common.definite"),
				cancelButtonText: this.$t("common.cancel"),
				type: "warning",
			}).then(() => {
				this.$api
					.request(this.$url.Product.delete, this.$method.delete, {
						id: row.id,
					})
					.then(res => {
						if (res.code === 0) {
							this.$notify({
								title: this.$t("common.tip"),
								message: res.msg,
								type: "success",
							});
							this.currentChange(this.page.pageIndex);
						}
					})
					.catch(() => {});
			});
		},
		handlerUploadImg(row) {
			this.productItem = row;
			this.isReUpload = false;
			this.showUploadImg = true;
		},
		handlerReUploadImg(row) {
			this.productItem = row;
			this.isReUpload = true;
			this.showUploadImg = true;
		},
		closeUploadImg() {
			this.showUploadImg = false;
		},
		refreshUploadImg() {
			this.showUploadImg = false;
			this.currentChange();
		},
		handlerLookImgs(row) {
			this.productItem = row;
			this.showLookImg = true;
		},
		closeLookImg() {
			this.showLookImg = false;
		},
		openSimilarDialog(row) {
			this.similarProduct = row;
			this.showSimilarDialog = true;
		},
		closeSimilarDialog() {
			this.showSimilarDialog = false;
		},
		refreshSimilarProduct() {
			this.currentChange(this.page.pageIndex);
		},
		handlerIsStatus(row, status) {
			if (!row.goodsOpenDoorSkuDTO) return status === null;
			if (row.goodsOpenDoorSkuDTO.skuResult === status) return true;
			return false;
		},
		handlerRejectReason(row) {
			if (!row.goodsOpenDoorSkuDTO) return "";
			return row.goodsOpenDoorSkuDTO.rejectReasion || "";
		},
		handlerROpenDoorStatus(row) {
			if (!row.goodsOpenDoorSkuDTO) return "";
			const skuResult = row.goodsOpenDoorSkuDTO.skuResult;
			if (skuResult === null || skuResult === undefined) return "";
			// Audit status: 0=Pending 1=Auditing 2=Approved 3=Rejected
			const statusMap = {
				0: "Pending",
				1: "Auditing",
				2: "Approved",
				3: "Rejected",
			};
			return statusMap[skuResult] || String(skuResult);
		},
		async handlerOpenDoorSh() {
			try {
				const res = await this.$api.dict("gp_opendoor_skuresult");
				if (res.code === 0) {
					this.openDoorResList = res.data;
				}
			} catch (error) {
				console.error("Error fetching open door status:", error);
			}
		},
	},
};
</script>

<style scoped>
.el-tag--mini {
	margin-right: 5px;
}
</style>
